// Module
var code = "<div class=\"md-whiteframe-z1 mn-module flex layout-column\"\r\n     mn-bind-html=\"payment/views/financial-statement-container.html\">\r\n</div>";
// Exports
module.exports = code;